module.exports = __webpack_public_path__ + "assets/img/3.cc1a4b6a.jpg";